import { create } from 'zustand';
import { useMessagesStore } from './messagesStore';
import { ApiUtils } from '@shared/utils';
import { MessagesApi, RequestStrategyEnum } from '@shared/api';

interface UseMarkAsReadStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  markAsRead: (messageId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useMarkAsReadStore = create<UseMarkAsReadStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  markAsRead: ApiUtils.wrapperApi(async (messageId, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await MessagesApi.markAsRead(messageId, signal);
      useMessagesStore.getState().readMessage(messageId);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: false }),
}));
